/* eslint-disable */
export const en_US = 'msg_codes_languagePref_english';
export const ja_JP = 'msg_codes_languagePref_japanese';
